module.exports = __webpack_public_path__ + "img/Yoghurt Cucumber Sauce.0cad3b96.png";